import type { InteractionBlueprintData } from "@/lib/contentParsers/interactionBlueprintSchema";
import { SparxTab } from "@/features/sparxsEditor/components/organisms/tab/editorTabsSelector";

export type SparxTabAvailabilityOptions = {
  hasTeaser: boolean;
};

export const getFirstAvailableSparxTab = (
  sparxData: InteractionBlueprintData | null,
  options: SparxTabAvailabilityOptions,
): SparxTab => {
  if (options.hasTeaser) return SparxTab.TEASER;
  if (sparxData?.content != null) return SparxTab.CONTENT;
  if (sparxData?.advisorContent != null) return SparxTab.ADVISOR;
  if (sparxData?.metadata != null) return SparxTab.METADATA;
  return SparxTab.CONTENT;
};

export const getAvailableSparxTabs = (
  sparxData: InteractionBlueprintData | null,
  options: SparxTabAvailabilityOptions,
): Set<SparxTab> => {
  const available = new Set<SparxTab>();
  if (options.hasTeaser) {
    available.add(SparxTab.TEASER);
  }
  if (sparxData?.content != null) {
    available.add(SparxTab.CONTENT);
  }
  if (sparxData?.advisorContent != null) available.add(SparxTab.ADVISOR);
  if (sparxData?.metadata != null) available.add(SparxTab.METADATA);
  return available;
};
